module.exports = __webpack_public_path__ + "media/assets/img/activitati-active-620698e2359b0153a7922fa82c42192b.svg";